import {baseRequestService} from "../base.ts";
import {Image} from "../../types/domain.ts";

export const imagesPost = (mime_type: string, data: string) => baseRequestService<Image>({
    url: '/images',
    method: 'POST',
    params: { mime_type },
    data
})